// extracted by mini-css-extract-plugin
export default {"Subpage":"advancedStatistics_Subpage__zxL6j","ChartsContainer":"advancedStatistics_ChartsContainer__fIJE6"};